module.exports = __webpack_public_path__ + "static/media/claims-icon-small.8c72d718.svg";